<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3">{{selectTitle}}</div>
        <div class="setting-addel mr-l15">
          <el-button size="mini" :disabled="!isAdd" @click="applyAutoApplyProc()"><i class="fas fa-plus"></i></el-button>
          <el-button size="mini" :disabled="!isDeleted" @click="deleteAutoApplyProc()"><i class="fas fa-minus"></i></el-button>
        </div>
      </div>
      <div>
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper ref="majorProcTable" @selection-change="procChangeSelection" row-class-name="c-dblclick" :data="dataList" :columns="procAutoColumns"
    remote pagination @condition-change="onTableConditionChange" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showSearchTool"  @row-dblclick="editAutoApplyProc"
    :total="total" style="width:100%;">
      <template slot-scope="scope" slot="autoCommand">
        <el-checkbox disabled v-model="scope.row.processStopAutostartFlag" true-label="1" false-label="0"></el-checkbox>
      </template>
    </el-table-wrapper>
    <w-major-proc-tmpl-popup ref="majorProcTmplPopup" @reload-data="loadData" :popup-type="procAutoPopupType" :majorProcTypeId="majorProcTypeId" :editRow="editRow"></w-major-proc-tmpl-popup>
  </div>
</template>

<script>
import { isNil, cloneDeep, clone } from 'lodash';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty } from '@/utils/string';
import ServerSettingAPI from '@/api/settings/server/server-settings';
import WMajorProcTmplPopup from '@/views/settings/server/ProcessSettings/MajorProcessRegistView/popup/MajorProcTmplPopup';

export default {
  name: 'WMajorProcTemplateList',
  components: {
    WMajorProcTmplPopup,
  },
  props: {
    selectPhysicalNode: Object,
  },
  data() {
    return {
      columnDefault,
      total: null,
      majorProcTypeId: null,
      isAdd: false,
      isDeleted: false,
      isEdit: false,
      editRow: {},
      showSearchTool: false,
      dataList: null,
      majorProcTypeName: '',
      procChangeList: [],
      procAutoPopupType: null,
      selectTitle: '',
      params: {},
      procAutoColumns: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'processId',
          label: '프로세스 ID',
          remoteProp: 'process_id',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'oneType',
          label: '1차 분류',
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'twoType',
          label: '2차 분류',
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'processName',
          label: '프로세스 명',
          remoteProp: 'process_name',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'processStopAutostartFlag',
          label: '명령어 자동실행 여부',
          scopedSlot: 'autoCommand',
          align: 'center',
          formatter: this.convertYNFlag,
        },
        {
          prop: 'processCommandStart',
          label: '동작 제어 명령',
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'processCommandStop',
          label: '정지 제어 명령',
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'processPort',
          label: '포트번호',
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  watch: {
    selectPhysicalNode: {
      handler() {
        if (!isNil(this.selectPhysicalNode)) {
          this.selectTitle = `[${this.selectPhysicalNode.label}] 중요 프로세스 템플릿 목록`;
          this.majorProcTypeName = this.selectPhysicalNode.majorProcTypeName;
          this.params = {};
          // 자동 등록 프로세스 템플릿 트리의 depth에 따라 로드되는 데이터를 달리한다.
          if (this.selectPhysicalNode.depth === 3) {
            this.isAdd = true;
            this.params.majorProcTypeId = this.selectPhysicalNode.majorProcTypeId;
          } else if (this.selectPhysicalNode.depth === 2) {
            this.isAdd = true;
            this.params.parentMajorProcTypeId = this.selectPhysicalNode.majorProcTypeId;
          } else {
            this.isAdd = false;
          }
          this.$refs.majorProcTable.clearFilter();
          this.$nextTick(() => {
            this.loadData();
          });
        }
      },
      immediate: true,
    },
    procChangeList: {
      handler() {
        if (this.procChangeList.length > 0) {
          this.isDeleted = true;
        } else {
          this.isDeleted = false;
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadData() {
      const tableParams = this.$refs.majorProcTable.getParameter();
      const params = {
        ...this.params,
        ...tableParams,
      };
      ServerSettingAPI.getMajorProcessList(params).then((response) => {
        if (response.data.success) {
          this.dataList = clone(response.data.data);
          this.total = response.data.total;
        }
      });
    },
    popupClose() {
      this.editRow = {};
    },
    /**
     * [applyAutoApplyProc 선택한 트리에 따른 그룹(또는 노드)에 자동 등록 프로세스를 추가한다.]
     * @author yelim
     * @return {[type]} [description]
     */
    applyAutoApplyProc() {
      this.editRow = {};
      this.majorProcTypeId = this.selectPhysicalNode.majorProcTypeId;
      this.procAutoPopupType = 'ADD';
      this.$refs.majorProcTmplPopup.open();
    },
    /**
     * [editAutoApplyProc 조회한 자동 등록 프로세스 목록의 항목을 더블클릭하여 수정한다.]
     * @author Ju
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    editAutoApplyProc(row) {
      this.editRow = cloneDeep(row);
      if (this.selectPhysicalNode.depth === 1 || this.selectPhysicalNode.depth === 2) {
        this.majorProcTypeId = row.majorProcTypeId;
      } else {
        this.majorProcTypeId = this.selectPhysicalNode.majorProcTypeId;
      }
      this.procAutoPopupType = 'EDIT';
      this.$refs.majorProcTmplPopup.open();
    },
    /**
     * [applyAutoApplyProc 선택한 트리에 따른 그룹(또는 노드)에 자동 등록 프로세스를 삭제한다.]
     * @author yelim
     * @return {[type]} [description]
     */
    deleteAutoApplyProc() {
      this.$confirm('삭제하시겠습니까?', '삭제', {
        confirmButtonText: '삭제',
        cancelButtonText: '취소',
      }).then(() => {
        ServerSettingAPI.deleteMajorProcess(this.procChangeList).then((response) => {
          if (response.data.success) {
            this.loadData();
          }
        });
      });
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    procChangeSelection(selectVal) {
      this.procChangeList = selectVal;
    },
    convertYNFlag(flag) {
      if (flag === 'Y' || flag === '1' || flag === 1 || flag === true) {
        return '1';
      }
      return '0';
    },
    onTableConditionChange() {
      this.loadData();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/server/ProcessSettings/MajorProcessRegistView/component/MajorProcTemplateList.vue